import { useState, useEffect } from 'react';

const useNewsletterModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        // Verificar si ya está suscrito - si está suscrito, no mostrar el modal
        const isSubscribed = localStorage.getItem('newsletter_subscribed') === 'true';
        if (isSubscribed) {
            console.log('Newsletter modal: Usuario ya suscrito, no mostrar modal');
            return;
        }

        // Obtener datos de navegación
        const visitCount = parseInt(localStorage.getItem('visit_count') || '0');
        const lastModalShown = parseInt(localStorage.getItem('last_modal_shown') || '0');
        const isFirstVisit = visitCount === 0;

        // Incrementar contador de visitas
        const newVisitCount = visitCount + 1;
        localStorage.setItem('visit_count', newVisitCount.toString());

        // Lógica para mostrar el modal
        let shouldShowModal = false;

        if (isFirstVisit) {
            // Primera visita: mostrar después de 3 segundos
            shouldShowModal = true;
            console.log('Newsletter modal: Primera visita detectada');
        } else if (newVisitCount - lastModalShown >= 20) {
            // Cada 20 navegaciones después de la primera vez
            shouldShowModal = true;
            console.log(`Newsletter modal: ${newVisitCount - lastModalShown} navegaciones desde última vez`);
        }

        if (shouldShowModal) {
            const timer = setTimeout(() => {
                setIsModalOpen(true);
                localStorage.setItem('last_modal_shown', newVisitCount.toString());
            }, isFirstVisit ? 3000 : 2000); // 3s para primera visita, 2s para siguientes

            return () => clearTimeout(timer);
        }
    }, []);

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const markAsSubscribed = (email) => {
        localStorage.setItem('newsletter_subscribed', 'true');
        localStorage.setItem('newsletter_email', email);
        setIsModalOpen(false);
    };

    return {
        isModalOpen,
        closeModal,
        markAsSubscribed
    };
};

export default useNewsletterModal;